// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo{height:24px;width:auto;fill:#005baa}@media (min-width:992px){.logo{height:36px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
